import {
  type AreaCode,
  type DeadlineShortening,
  type DocumentType,
  type RegistryAdjacentKind,
  type RequestType,
} from "../types";

export const AREA_A_PREFECTURES = [
  "東京都",
  "神奈川県",
  "千葉県",
  "埼玉県",
  "愛知県",
  "大阪府",
  "京都府",
  "兵庫県",
] as const;

export const AREA_B_CITIES: Readonly<Record<string, readonly string[]>> = {
  北海道: ["札幌市", "旭川市", "函館市"],
  青森県: ["青森市", "八戸市"],
  岩手県: ["盛岡市"],
  宮城県: ["仙台市"],
  秋田県: ["秋田市"],
  山形県: ["山形市"],
  福島県: ["福島市", "郡山市", "いわき市"],
  茨城県: ["水戸市"],
  栃木県: ["宇都宮市"],
  群馬県: ["前橋市", "高崎市"],
  新潟県: ["新潟市"],
  石川県: ["金沢市"],
  富山県: ["富山市"],
  福井県: ["福井市"],
  長野県: ["長野市", "松本市"],
  山梨県: ["甲府市"],
  岐阜県: ["岐阜市"],
  静岡県: ["静岡市", "浜松市"],
  三重県: ["四日市市", "津市"],
  滋賀県: ["大津市"],
  奈良県: ["奈良市"],
  和歌山県: ["和歌山市"],
  鳥取県: ["鳥取市"],
  島根県: ["松江市"],
  岡山県: ["岡山市", "倉敷市"],
  広島県: ["広島市", "呉市", "福山市"],
  山口県: ["下関市"],
  徳島県: ["徳島市"],
  香川県: ["高松市"],
  愛媛県: ["松山市"],
  高知県: ["高知市"],
  福岡県: ["福岡市", "北九州市", "久留米市"],
  佐賀県: ["佐賀市"],
  長崎県: ["長崎市", "佐世保市"],
  熊本県: ["熊本市"],
  大分県: ["大分市"],
  宮崎県: ["宮崎市"],
  鹿児島県: ["鹿児島市"],
  沖縄県: ["那覇市"],
};

export const REQUEST_TYPE_LABELS: Readonly<Record<RequestType, string>> = {
  simple: "簡易調査",
  detailed: "詳細調査（重説作成）",
  sales_contract: "売買契約書作成",
  important_explanation_check: "重説チェック",
  custom_agreement: "個別に合意した調査",
};

export const DOCUMENT_TYPE_LABELS: Readonly<Record<DocumentType, string>> = {
  registry: "登記簿謄本",
  public_map: "公図",
  land_survey_map: "地積測量図",
  building_drawing: "建物図面",
  closed_registry: "閉鎖謄本",
};

export const REGISTRY_ADJACENT_KIND_LABELS: Readonly<
  Record<RegistryAdjacentKind, string>
> = {
  full: "全部事項証明書",
  owner: "所有者事項証明書",
  summary: "要約書",
};

export const BASE_PRICES: Readonly<
  Record<RequestType, Readonly<Record<AreaCode, number | null>>>
> = {
  simple: { A: 30000, B: 40000, C: 50000, D: null },
  detailed: { A: 150000, B: 160000, C: 170000, D: null },
  sales_contract: { A: 50000, B: 50000, C: 50000, D: 50000 },
  important_explanation_check: {
    A: 65000,
    B: 65000,
    C: 65000,
    D: 65000,
  },
  custom_agreement: { A: null, B: null, C: null, D: null },
};

export const SIMPLE_WITH_PHOTO_PRICES: Readonly<
  Record<AreaCode, number | null>
> = { A: 35000, B: 45000, C: 55000, D: null };

export const STANDARD_DELIVERIES: Readonly<
  Record<RequestType, Readonly<Record<AreaCode, string>>>
> = {
  simple: { A: "5営業日", B: "6営業日", C: "7営業日", D: "要相談" },
  detailed: {
    A: "10営業日",
    B: "11営業日",
    C: "12営業日",
    D: "要相談",
  },
  sales_contract: {
    A: "5営業日",
    B: "5営業日",
    C: "5営業日",
    D: "5営業日",
  },
  important_explanation_check: {
    A: "10営業日",
    B: "10営業日",
    C: "10営業日",
    D: "10営業日",
  },
  custom_agreement: { A: "要相談", B: "要相談", C: "要相談", D: "要相談" },
};

export const DEADLINE_SHORTENING_RATES: Readonly<
  Record<DeadlineShortening, number>
> = { 0: 0, 1: 0.05, 2: 0.1, 3: 0.15 };

export const POSTAL_FEE = 430;

/** 最寄駅まで徒歩15分以上の物件に、1件につき1回加算する（価格表「公共交通機関の拠点から徒歩15分以上」）。判定は API が行う */
export const REMOTE_AREA_FEE = 10000;

/** 最寄駅まで徒歩30分以上の物件に、1件につき1回加算する。判定は API が行う */
export const VEHICLE_REQUIRED_FEE = 20000;
